import axios, { AxiosResponse } from "axios";
import { getUserToken } from "utils/getToken";

export const ApiGetCourseERPGraphql = process.env.REACT_APP_GET_COURSE_ERP_URL;

export const ApiGetCouseERPInstance = axios.create({
  baseURL: ApiGetCourseERPGraphql,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: getUserToken(),
  },
  method: "POST",
});

export async function ApiGetCouseERPRequest<responseDataType = any>({
  query,
  variables,
}: {
  query: string;
  variables?: { [key: string]: any };
}): Promise<AxiosResponse<{ data?: responseDataType; errors?: Error[] }>> {
  return ApiGetCouseERPInstance.request<{
    data?: responseDataType;
    errors?: Error[];
  }>({
    data: {
      query,
      variables,
    },
    headers: {
      // ...headers,
      Authorization: localStorage.getItem("UserToken"),
    }, // Passe os cabeçalhos para a requisição
  });
}

export interface DataState<DataType = any> {
  loading?: boolean;
  error?: Error;
  data?: DataType;
}

export async function ApiGetCouseERPWithSetData<T = any>({
  query,
  variables,
  setData,
}: {
  query: string;
  variables?: { [key: string]: any };
  setData: (data: DataState<T>) => void;
}): Promise<DataState<T>> {
  return ApiGetCouseERPRequest<T>({ query, variables })
    .then((response) => {
      if (!response?.data?.data) {
        const respError: DataState<T> = {
          loading: false,
          error: response?.data?.errors?.[0] || new Error("mediaFiles not found"),
          data: undefined,
        };
        setData(respError);
        return respError;
      }
      const respSuccess: DataState<T> = {
        error: undefined,
        loading: false,
        data: response.data.data,
      };
      setData(respSuccess);
      return respSuccess;
    })
    .catch((error) => {
      console.error(error);
      const respError: DataState<T> = {
        loading: false,
        error,
        data: undefined,
      };
      setData(respError);
      return respError;
    });
}
